<template>
  <div class="header">
    <!-- 订单信息： -->
    <div class="label">{{ $t("message.orderInformation") }} :
      <!-- 海外仓标识  -->
      <div class="identifier">{{ detail.warehouse_inbound_name }}</div>
      <!-- 集运标识  -->
      <el-popover placement="top" trigger="hover" v-if="detail.co_porder_sn || detail.coPorder != false">
        <p> {{ detail.co_porder_sn }}</p>
        <p v-for="(item, index) in detail.coPorder" :key="index">
          {{ item }}
        </p>
        <div class="identifier" slot="reference">{{ detail.merge_type }}</div>
      </el-popover>
    </div>
    <div class="item">
      <!-- 客户名： -->
      <p>
        <span>{{ $t("message.customerName") }}:</span>
        <router-link
          :to="'/user/basicInformation?userID=' + detail.user_id + '&encryption=' + $md5(detail.user_id + '')"
          target="_blank" style="color: #fff;">
          {{ detail.realname }}
        </router-link>
      </p>
      <!-- 配送单号： -->
      <p>
        <span>{{ $t("message.deliveryNoteNumber") }}:</span>{{ detail.porder_sn }}
      </p>
      <!-- 配送单类别： -->
      <p>
        <span>{{ $t("message.porderType") }}:</span>{{ detail.merge_type }}
        <!-- 聊天 -->
        <b v-if="detail.user">
          <a :href="'https://www.chatwork.com/#!rid' + detail.user.chatwork" target="_blank" v-if="detail.user.chatwork"
            style=" color: #fff;">
            <img src="@/assets/user/CW.svg" alt="" style="vertical-align: middle;">
            chatwork
          </a>
          <a style=" color: #fff;" @click="chat(item)" v-else href="javascript:;">
            <img src="@/assets/user/raku.svg" alt="" style=" vertical-align: middle;">
            RAKUCHAT
          </a>
        </b>
      </p>
    </div>
    <div class="border"></div>
    <div class="item">
      <!-- 配送单属性： -->
      <div style="margin-bottom: 20px;">
        <span>{{ $t("message.porderProperty") }}: </span>
        <div class="attribute">
          <attributeName :name="detail.porder_attribute" />
        </div>
      </div>
      <!-- FBA操作： -->
      <p>
        <span>{{ $t("message.fBAOperation") }}:</span>{{ detail.fba_name }}
        <b style="color: #67C23A;font-size: 18px;vertical-align: middle;" v-if="detail.is_fba">贴标</b>
      </p>
      <!-- 检品员 -->
      <p>
        <span>{{ $t("message.inspector") }}:</span>{{ detail.j_name }}
      </p>
    </div>
    <div class="border"></div>
    <div class="item">
      <!-- 业务员 -->
      <p>
        <span>{{ $t("message.salesman") }}:</span>{{ detail.y_name }}
      </p>
      <!-- 采购员 -->
      <p>
        <span>{{ $t("message.buyer") }}:</span>{{ detail.g_name }}
      </p>
      <!-- 配送员 -->
      <p>
        <span>{{ $t("message.distributionMember") }}:</span>{{ detail.p_name }}
      </p>
      <!-- 封箱员 -->
      <p>
        <span>{{ $t("message.porderSealer") }}:</span>{{ detail.sealer_admin ? detail.sealer_admin.realname : '' }}
      </p>
    </div>
    <div class="border"></div>
    <div class="item user_extend">
      <!-- 注意事项 -->
      <span>{{ $t("message.mattersNeedingAttention") }}:</span>
      <textarea name="" id="" v-model="detail.user_extend.y_remark" readonly v-if="detail.user_extend"></textarea>
    </div>
    <!-- 废弃 -->
    <el-button type="primary" v-if="detail.status == 22 || detail.status == 50 || detail.status == 30" size="small"
      @click="$refs.discard.dialogVisible = true" class="abandon">
      {{ $t('message.abandon') }}
    </el-button>
    <!-- 客户界面链接 -->
    <el-button type="primary" size="small" class="link"
      @click="copy('https://www.rakumart.com/deliveryDetails?pOrder_sn=' + detail.porder_sn)">
      客户界面链接
    </el-button>
    <!-- 一键读取历史标签 -->
    <el-button type="primary" size="small" class="tag" v-if="detail.status == 20" @click="setTagTextByNo">
      一键读取历史标签
    </el-button>
    <!-- 转入长存仓库（配送单待入金） -->
    <el-button type="success" size="small" class="transfer-long-storage" v-if="detail.status == 30"
      @click="convertFreightToOrderBox">
      {{ $t('message.transferToLongTermStorageWarehouse') }}
    </el-button>

    <div class="quick-actions">
      <!-- 调整操作员：配送单所有状态均可操作 -->
      <el-button type="success" size="small" @click="allot" v-if="isAuth(221)">
        {{ $t("message.adjustTheOperator") }}
      </el-button>
      <!-- 标识贴标：配送单待翻译 -->
      <el-button type="primary" size="small" @click="addFbaSign" v-if="(detail.status == 20 || detail.status == 22)&& isAuth(227)">
        {{ $t("message.markingAndLabeling") }}
      </el-button>
      <!-- 关联子单号：配送单待翻译、待装箱、待报价 -->
      <el-button type="success" size="small" @click="associateASuborderNumber"
        v-if="(detail.status == 20 || detail.status == 21 || detail.status == 22) && isAuth(224) && !detail.p_porder_sn">
        {{ $t("message.associateASuborderNumber") }}
      </el-button>
    </div>

    <!-- 分配 -->
    <el-dialog :title="$t('message.adjustTheOperator')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="400px" center>
      <div class="allot">
        <el-select v-model="allotVal.y_id" class="item" filterable :placeholder="$t('message.adjustBusiness')">
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id" />
        </el-select>
        <el-select v-model="allotVal.p_id" class="item" filterable :placeholder="$t('message.distribution')">
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id" />
        </el-select>
        <el-select v-model="allotVal.fba_user" class="item" filterable placeholder="FBA">
          <el-option v-for="item in j" :key="item.id" :label="item.realname" :value="item.id" />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <el-button type="primary" @click="allotSave">{{ $t("message.save") }}</el-button>
      </span>
    </el-dialog>

    <!-- 标识贴标 -->
    <addFbaSign ref="addFbaSign" :porderSnSet="porderSnSet" />
    <!-- 关联子单号 -->
    <andSingle v-if="andSingleDialogVisible" :itemData="itemData" />

    <!-- 废弃申请 -->
    <discard ref="discard" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import discard from './discard'
import addFbaSign from '@/components/porder/components/addFbaSign'
import andSingle from '@/components/porder/components/andSingle'
export default {
  components: {
    discard,
    addFbaSign,
    andSingle,
  },
  computed: {
    ...mapState({
      detail: (state) => state.porderDetail.detail,
      boxList: (state) => state.porderDetail.boxList,
    }),
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    j() {
      return this.$store.state.authWorkGroupAdmin.j;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  data() {
    return {
      dialogVisible: false,
      allotVal: {
        y_id: '',
        p_id: '',
        fba_user: '',
      },
      porderSnSet: [],
      andSingleDialogVisible: false,
      itemData: {},
    };
  },
  methods: {
    // 刷新配送单详情，供快捷操作及复用弹窗调用
    generalList() {
      this.$store.dispatch("porderDetail", { porder_sn: this.detail.porder_sn });
    },
    // 显示分配弹框
    allot() {
      const yAdmin = this.y.find(item => item.realname == this.detail.y_name);
      const pAdmin = this.p.find(item => item.realname == this.detail.p_name);
      const fbaAdmin = this.j.find(item => item.realname == this.detail.fba_name);
      this.allotVal.y_id = yAdmin ? yAdmin.id : '';
      this.allotVal.p_id = pAdmin ? pAdmin.id : '';
      this.allotVal.fba_user = fbaAdmin ? fbaAdmin.id : '';
      this.dialogVisible = true;
    },
    // 分配操作员
    allotSave() {
      const datas = {
        porder_sn_set: [this.detail.porder_sn],
        y_id: this.allotVal.y_id,
        p_id: this.allotVal.p_id,
        fba_user: this.allotVal.fba_user,
      };
      this.$api.porderApi.allotYGP(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.generalList();
      });
    },
    // 配送单-FBA-添加、删除标识
    addFbaSign() {
      this.porderSnSet = [this.detail.porder_sn];
      this.$refs.addFbaSign.dialogVisible = true;
      this.$refs.addFbaSign.typeSet = [];
      this.$refs.addFbaSign.type = '1';
    },
    // 关联子单号
    associateASuborderNumber() {
      if (this.detail.p_porder_sn) return this.$message.error('子单号不能关联子单号');
      this.itemData = JSON.parse(JSON.stringify(this.detail));
      this.andSingleDialogVisible = true;
    },
    //打开聊天
    chat() {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (location.host.indexOf('.co.jp') == -1) {
        window.open(
          `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&uid=${this.detail.user.id}&token=${token}`,
          japanUserRoleInfo,
          "height=700, width=1260, left=" +
          iLeft +
          ", top=" +
          iTop +
          ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        );
      }
    },
    // 获取当前配送单全部箱子 ID（freight_id）
    getAllFreightIds() {
      const freightIds = []
      this.boxList.forEach(item => {
        item.group.forEach(group => {
          group.list.forEach(box => {
            if (box.id) freightIds.push(box.id)
          })
        })
      })
      return freightIds
    },
    // 配送单待入金：转入长存仓库，二次确认后取消配送单并转入转库列表
    convertFreightToOrderBox() {
      const freight_ids = this.getAllFreightIds()
      if (!freight_ids.length) {
        return this.$message.error(this.$t('message.noTransferableBox'))
      }
      this.$confirm(
        this.$t('message.convertFreightToOrderBoxConfirm'),
        this.$t('message.hint'),
        {
          confirmButtonText: this.$t('message.confirmProposeTransfer'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning',
          center: true,
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        this.$api.inventoryTransferApi.convertFreightToOrderBox({ freight_ids }).then(res => {
          this.$message.success(res.msg)
          this.$store.dispatch('porderDetail', { porder_sn: this.detail.porder_sn })
          this.$store.commit('setBoxIds', [])
        })
      }).catch(() => { })
    },
    // 一键读取历史标签
    setTagTextByNo() {
      let datas = {
        user_id: this.detail.user_id,
        tagList: []
      }
      this.detail.list.forEach(item => {
        if (item.checked) {
          item.porder_detail_tag.forEach(tag => {
            datas.tagList.push({
              id: tag.id,
              no: tag.no
            })
          })
        }
      })
      if (datas.tagList.length == 0) {
        this.$message.error('请选商品');
        return;
      }
      this.$api.porderApi.setTagTextByNo(datas).then(res => {
        this.$message.success(res.msg);
        this.$store.dispatch("porderDetail", {
          porder_sn: this.detail.porder_sn,

        })

      })
    }
  },
};
</script>
<style lang='scss' scoped>
.header {
  padding: 24px;
  background-color: #32323c;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  min-width: 1862px;
  position: relative;

  .abandon {
    position: absolute;
    right: 24px;
    bottom: 24px;
    opacity: 0.5;
  }

  .link {
    position: absolute;
    right: 24px;
    top: 24px;
  }

  .tag {
    position: absolute;
    right: 24px;
    bottom: 24px;
  }

  .transfer-long-storage {
    position: absolute;
    right: 24px;
    top: 62px;
  }

  .quick-actions {
    position: absolute;
    right: 180px;
    bottom: 24px;
    display: flex;
    flex-direction: column;

    .el-button+.el-button {
      margin-top: 10px;
      margin-left: 0;
    }
  }

  .label {
    margin-right: 60px;
    max-width: 140px;

    .identifier {
      margin-top: 10px;
      font-size: 25px;
      font-weight: 600;
      color: #B4272D;
    }
  }

  .item {
    p {
      margin-bottom: 20px;

      span {
        display: inline-block;
        width: 80px;
      }

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .attribute {
      display: inline-block;
      width: 100px;
      vertical-align: middle;
      line-height: 18px;
    }
  }

  .border {
    margin: 0 80px;
    background-color: #545467;
    width: 1px;
  }
}

.allot {
  .item {
    width: 100%;
    margin-bottom: 12px;
  }
}

.SVIP {
  font-size: 20px;
  font-weight: bold;
  color: #F7E203;
  vertical-align: middle;
}

.user_extend {
  display: flex;

  textarea {
    width: 500px;
    height: 100%;
    background-color: #32323c;
    color: #fff;
    padding: 3px;
    resize: none;
    border: none;
    font-size: 14px;
  }
}
</style>
